import './App.css';
import Homepage from './Components/Homepage';
import {
  BrowserRouter, Route, Routes
} from "react-router-dom";
import NotFound from './Components/NotFound';
import Dashboard from './Components/Dashboard';
import { createBrowserHistory } from 'history'
const history = createBrowserHistory()

function App() {
  return (
    <div className="App">
      <Routes history={history}>
            <Route path="/dashboard" element={<Dashboard/>}/>
            <Route path="/notfound" element={<NotFound/>}/>
            <Route path="/" element={<Homepage/>}/>
            <Route path="*" element={<NotFound/>}/>
      </Routes>
      <p className='MIM'>MIM</p>
      <p className='Version'>Sales Update v1.0.6</p>
    </div>
  );
}

export default App;
